module.exports = __webpack_public_path__ + "static/img/gsbditu.357e7fbf.jpg";